const LINK_REL = 'ugc nofollow noopener noreferrer';

export function qualifyUserGeneratedLinks(html: string): string {
  if (!html) return '';

  return html.replace(/<a\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gi, (_match, attributes: string) => {
    const qualifiedAttributes = attributes
      .replace(/\s+rel\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
      .replace(/\s+target\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
      .trim();
    const prefix = qualifiedAttributes ? ` ${qualifiedAttributes}` : '';

    return `<a${prefix} target="_blank" rel="${LINK_REL}">`;
  });
}
